import { Subject } from 'rxjs';

const subject = new Subject();

export const trackingsheetUpdateService = {
  sendTrackingsheet: trackingsheet => subject.next(trackingsheet),
  clearTrackingsheet: () => subject.next(),
  getTrackingsheet: () => subject.asObservable()
};
